module.exports = __webpack_public_path__ + "static/media/preview.594f72eb.png";